export const PASSWORD_RULES = [
  'At least one digit (0-9)',
  'At least one lowercase (a-z)',
  'At least one uppercase (A-Z)',
  'At least one non-alphanumeric character',
  'At least 8 characters',
  'Must not contain your name or email address',
  'Must not contain your company name',
  'Must not contain < or >',
  'Must not contain common words (e.g., "admin", "1234")',
] as const;

export const EMAIL_REG_EXP = /^[\w%+.-]+@[\d.A-Za-z-]+\.[A-Za-z]{2,}$/;
export const PHONE_REG_EXP = /^\+\d{10,15}$/;
export const PHONE_MAX_LENGTH = 15;

export const COMPANY_MAX_LENGTH = 100;
export const COMPANY_MIN_LENGTH = 2;
export const COMPANY_VALID_CHARS_REGEX = /^[\d\s&'+,./A-Za-z-]*$/;

export const NAME_REGEX = /^[\sA-Za-z]+$/;
export const CONFIRMATION_CODE_REGEX = /^\d{6}$/;
export const ACCESS_FIELD_REGEX = /^[\d\sA-Za-z]+$/;

export const NAME_MIN = 2;
export const NAME_MAX = 50;
export const CONFIRMATION_CODE_LENGTH = 6;
export const PASSWORD_MIN_LENGTH = 8;
export const ACCESS_FIELD_MIN_LENGTH = 3;
export const ACCESS_FIELD_MAX_LENGTH = 200;
